import React from "react";
import classes from "./AuthSidebar.module.css";
import { circles } from "../../../assets/constant";
import { LoginTextIcon } from "../../../constant";
import PaddingContainer from "../../../components/PaddingContainer";
const AuthSidebar = ({ children }) => {
  return (
    <div className={classes["authLayout"]}>
      <div className={classes["authSidebarLeft"]}>
        <LoginTextIcon className="img-fluid" />
      </div>
      {children}
    </div>
  );
};

export default AuthSidebar;
